import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import axios from 'axios';
import { Card, Metric, Text } from '@tremor/react';

const apiUrlSeleccionMensual = `${process.env.REACT_APP_API_URL}/infomensual`;

const GraficosMensuales = ({ sedeSeleccionada }) => {
  const [datos, setDatos] = useState([]);

  useEffect(() => {
    const obtenerDatos = async () => {
      try {
        let url = apiUrlSeleccionMensual;
        if (sedeSeleccionada) {
          url += `?id_sede=${sedeSeleccionada}`;
        }
        console.log('[CardGripMapMensual] Llamando API:', url);
        const res = await axios.get(url);
        console.log('[CardGripMapMensual] Respuesta API:', res.data);
        setDatos(res.data);
      } catch (err) {
        console.error('[CardGripMapMensual] Error:', err);
        setDatos([]);
      }
    };

    obtenerDatos();
  }, [sedeSeleccionada]);

  const meses = {};
  const platosContador = {};
  const bebidasContador = {};

  datos.forEach((pedido) => {
    const fecha = new Date(pedido.fecha);
    const key = `${fecha.getFullYear()}-${String(fecha.getMonth() + 1).padStart(2, '0')}`;
    const tipoNormalizado = (pedido.tipo || '').toLowerCase();
    const esBebida = tipoNormalizado.includes('bebida');

    if (!meses[key]) {
      meses[key] = { Menu: 0, Veggie: 0, Pechuga: 0, General: 0 };
    }

    // Agrupar General y Menu como 'Menu' para el gráfico de barras por mes
    const tipoAgrupado = (pedido.tipo === 'General' || pedido.tipo === 'Menu') ? 'Menu' : pedido.tipo;
    if (meses[key].hasOwnProperty(tipoAgrupado)) {
      meses[key][tipoAgrupado] += 1;
    }

    // Contadores para rankings por nombre
    const nombreItem = pedido.nombre;
    if (nombreItem) {
      if (esBebida) {
        bebidasContador[nombreItem] = (bebidasContador[nombreItem] || 0) + 1;
      } else {
        platosContador[nombreItem] = (platosContador[nombreItem] || 0) + 1;
      }
    }
  });

  const categorias = Object.keys(meses).sort().map((mes) =>
    new Date(mes + '-01T00:00').toLocaleDateString('es-ES', {
      month: 'short',
      year: 'numeric',
    })
  );

  const dataMenu = Object.values(meses).map((m) => (m.Menu || 0) + (m.General || 0));
  const dataVeggie = Object.values(meses).map((m) => m.Veggie || 0);
  const dataPechuga = Object.values(meses).map((m) => m.Pechuga || 0);

  console.log('[CardGripMapMensual] Datos recibidos:', datos.length, datos);
  console.log('[CardGripMapMensual] Meses agrupados:', meses);
  console.log('[CardGripMapMensual] Total por tipo:', { Menu: dataMenu.reduce((a, b) => a + b, 0), Veggie: dataVeggie.reduce((a, b) => a + b, 0), Pechuga: dataPechuga.reduce((a, b) => a + b, 0) });

  const totalPorTipo = {
    Menu: dataMenu.reduce((a, b) => a + b, 0),
    Veggie: dataVeggie.reduce((a, b) => a + b, 0),
    Pechuga: dataPechuga.reduce((a, b) => a + b, 0),
  };

  const seriesBar = [
    { name: 'Menú', data: dataMenu },
    { name: 'Veggie', data: dataVeggie },
    { name: 'Pechuga', data: dataPechuga },
  ];

  const seriesPie = [totalPorTipo.Menu, totalPorTipo.Veggie, totalPorTipo.Pechuga];

  const optionsBar = {
    chart: {
      id: 'bar-cantidades',
      foreColor: '#374151',
      stacked: false,
      toolbar: { show: false },
      background: 'transparent'
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '60%',
      },
    },
    dataLabels: {
      enabled: true,
      style: { colors: ['#fff'], fontWeight: 'bold' },
    },
    xaxis: {
      categories: categorias,
      labels: { style: { colors: '#6b7280', fontWeight: 600 } },
    },
    yaxis: {
      labels: { style: { colors: '#6b7280', fontWeight: 600 } },
    },
    legend: {
      labels: { colors: '#374151' },
      position: 'bottom',
    },
    tooltip: {
      theme: 'light',
    },
    grid: {
      borderColor: '#e5e7eb',
    },
  };

  const optionsPie = {
    labels: ['Menú', 'Veggie', 'Pechuga'],
    legend: {
      position: 'bottom',
      labels: { colors: '#374151' },
    },
    dataLabels: {
      style: {
        colors: ['#fff'],
        fontWeight: 'bold'
      },
    },
    chart: {
      foreColor: '#374151',
    },
    tooltip: {
      theme: 'light',
    },
  };

  // 🍽️ Top platos
  const topPlatos = Object.entries(platosContador)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 5);

  const platosLabels = topPlatos.map(([plato]) => plato);
  const platosCantidades = topPlatos.map(([_, cantidad]) => cantidad);

  // 🥤 Top bebidas
  const topBebidas = Object.entries(bebidasContador)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 5);

  const bebidasLabels = topBebidas.map(([bebida]) => bebida);
  const bebidasCantidades = topBebidas.map(([_, cantidad]) => cantidad);

  const createHorizontalOptions = (cats) => ({
    chart: {
      type: 'bar',
      foreColor: '#374151',
      toolbar: { show: false },
      background: 'transparent'
    },
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: '60%',
        distributed: true,
      },
    },
    dataLabels: {
      enabled: true,
      style: { colors: ['#fff'], fontWeight: 'bold' },
    },
    xaxis: {
      categories: cats,
      labels: { style: { colors: '#6b7280', fontWeight: 600 } },
    },
    yaxis: {
      labels: { style: { colors: '#6b7280', fontWeight: 600 } },
    },
    legend: { show: false },
    tooltip: { theme: 'light' },
    grid: {
      borderColor: '#e5e7eb',
    },
  });

  return (
    <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-6">

      {/* Totales */}
      <div className="lg:col-span-12 grid grid-cols-1 md:grid-cols-4 gap-4">
        <Card className="bg-white border-2 border-blue-200 shadow-lg hover:shadow-xl transition-all">
          <Metric className="!text-gray-900 !text-base !font-bold !mb-1">Total pedidos</Metric>
          <Text className="!text-blue-700 !text-4xl !font-bold">{totalPorTipo.Menu + totalPorTipo.Veggie + totalPorTipo.Pechuga}</Text>
        </Card>
        <Card className="bg-white border-2 border-blue-200 shadow-lg hover:shadow-xl transition-all">
          <Metric className="!text-gray-900 !text-base !font-bold !mb-1">Menú</Metric>
          <Text className="!text-blue-700 !text-4xl !font-bold">{totalPorTipo.Menu}</Text>
        </Card>
        <Card className="bg-white border-2 border-green-200 shadow-lg hover:shadow-xl transition-all">
          <Metric className="!text-gray-900 !text-base !font-bold !mb-1">Veggie</Metric>
          <Text className="!text-green-700 !text-4xl !font-bold">{totalPorTipo.Veggie}</Text>
        </Card>
        <Card className="bg-white border-2 border-orange-200 shadow-lg hover:shadow-xl transition-all">
          <Metric className="!text-gray-900 !text-base !font-bold !mb-1">Pechuga</Metric>
          <Text className="!text-orange-700 !text-4xl !font-bold">{totalPorTipo.Pechuga}</Text>
        </Card>
      </div>

      {/* Gráfico de barras por mes */}
      <div className="lg:col-span-8">
        <Card className="p-6 bg-white rounded-2xl border-2 border-blue-200 shadow-xl h-full">
          <Metric className="mb-6 text-gray-800 font-bold flex items-center gap-2">
            <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            </svg>
            Reservas por tipo (mensual)
          </Metric>
          <Chart options={optionsBar} series={seriesBar} type="bar" height={350} />
        </Card>
      </div>

      {/* Proporción total */}
      <div className="lg:col-span-4">
        <Card className="p-6 bg-white rounded-2xl border-2 border-blue-200 shadow-xl h-full">
          <Metric className="mb-6 text-gray-800 font-bold flex items-center gap-2">
            <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z" />
            </svg>
            Proporción total
          </Metric>
          <Chart options={optionsPie} series={seriesPie} type="pie" height={350} />
        </Card>
      </div>

      {/* Ranking de platos */}
      <div className="lg:col-span-6">
        <Card className="p-6 bg-white rounded-2xl border-2 border-green-200 shadow-xl">
          <Metric className="mb-6 text-gray-800 font-bold flex items-center gap-2">
            <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
            </svg>
            Platos más solicitados
          </Metric>
          {platosLabels.length > 0 ? (
            <Chart
              options={createHorizontalOptions(platosLabels)}
              series={[{ name: 'Pedidos', data: platosCantidades }]}
              type="bar"
              height={300}
            />
          ) : (
            <Text className="text-gray-500 text-center py-10">No hay datos de platos aún</Text>
          )}
        </Card>
      </div>

      {/* Ranking de bebidas */}
      <div className="lg:col-span-6">
        <Card className="p-6 bg-white rounded-2xl border-2 border-cyan-200 shadow-xl">
          <Metric className="mb-6 text-gray-800 font-bold flex items-center gap-2">
            <svg className="w-6 h-6 text-cyan-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" />
            </svg>
            Ranking de Bebidas
          </Metric>
          {bebidasLabels.length > 0 ? (
            <Chart
              options={{
                ...createHorizontalOptions(bebidasLabels),
                colors: ['#06b6d4']
              }}
              series={[{ name: 'Pedidos', data: bebidasCantidades }]}
              type="bar"
              height={300}
            />
          ) : (
            <Text className="text-gray-500 text-center py-10">No hay datos de bebidas aún</Text>
          )}
        </Card>
      </div>

    </div>
  );
};

export default GraficosMensuales;


